/* @agnoplay-aws/agnoplay-plugins 1.0.5 (2024-07-08T17:04:47.965Z) */
var h = Object.defineProperty;
var p = (o, t, e) => t in o ? h(o, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : o[t] = e;
var i = (o, t, e) => (p(o, typeof t != "symbol" ? t + "" : t, e), e);
class d {
  constructor() {
    i(this, "state", {});
    i(this, "teasers", []);
    i(this, "setTeasers", (t) => {
      t.forEach((e) => {
        const s = typeof e.el == "string" ? document.querySelector(e.el) : e.el, r = s.querySelector('[data-spark-image="true"]') || s.querySelector("img");
        if (r) {
          const n = {
            mediaId: e.mediaId,
            el: s,
            image: r
          };
          this.attachListeners(n), this.teasers.push(n);
        }
      });
    });
    i(this, "attachListeners", (t) => {
    });
    i(this, "detachListeners", (t) => {
      t.cleanup && t.cleanup();
    });
    i(this, "getState", (t) => this.state[t]);
    i(this, "setState", (t, e) => this.state[t] = {
      ...this.state[t],
      ...e
    });
    i(this, "removeState", (t) => {
      delete this.state[t];
    });
  }
}
function m({ image: o, previewUrl: t }) {
  const e = v(o), s = f(t);
  e.appendChild(s);
  const r = o.parentNode, n = getComputedStyle(r);
  return n.position !== "absolute" && n.position !== "relative" && (r.style.position = "relative"), o.insertAdjacentElement("afterend", e), {
    el: e,
    video: s
  };
}
function v(o) {
  const t = document.createElement("div");
  t.style.position = "absolute", t.style.backgroundColor = "#000000", t.style.width = o.offsetWidth + "px", t.style.height = o.offsetHeight + "px";
  const e = o.getBoundingClientRect(), r = o.parentNode.getBoundingClientRect();
  return t.style.top = e.top - r.top + "px", t.style.left = e.left - r.left + "px", t;
}
function f(o) {
  const t = document.createElement("video");
  t.playsInline = !0, t.muted = !0, t.loop = !0, t.style.width = "100%", t.style.height = "100%";
  const e = document.createElement("source");
  return e.src = o, e.type = "video/mp4", t.appendChild(e), t;
}
const y = "https://mediahuis-playlist.zndznd.com/playlist/preview/{MEDIA_IDS}";
class w extends d {
  constructor(e) {
    super();
    i(this, "state", {});
    i(this, "previewUrls", {});
    i(this, "update", (e) => {
      this.setTeasers(e.items), this.setPreviewUrls({
        mediaIds: e.items.map((s) => s.mediaId)
      });
    });
    i(this, "remove", () => {
      this.teasers.forEach((e) => {
        this.detachListeners(e);
      }), this.teasers = [], this.previewUrls = {}, Object.keys(this.state).forEach((e) => {
        this.removePreview(e);
      });
    });
    i(this, "setPreviewUrls", ({ mediaIds: e }) => {
      const s = Array.isArray(e) ? e : [e];
      if (s != null && s.length) {
        const r = y.replace(/\{MEDIA_IDS\}/gi, s.join(","));
        fetch(r).then(async (n) => n.json()).then((n) => {
          var a;
          n && ((a = n.items) != null && a.length) && !n.error && n.items.forEach((c) => {
            var l;
            ((l = c == null ? void 0 : c.previewvideo) == null ? void 0 : l.status) === "ready" && (this.previewUrls[c.id] = c.previewvideo.url);
          });
        });
      }
    });
    i(this, "attachListeners", (e) => {
      const s = () => {
        const { mediaId: n } = e, a = this.previewUrls[n];
        a && this.addPreview({
          teaser: e,
          previewUrl: a
        });
      }, r = () => {
        const { mediaId: n } = e;
        this.removePreview(n);
      };
      e.el.addEventListener("mouseenter", s), e.el.addEventListener("mouseleave", r), e.cleanup = () => {
        e.el.removeEventListener("mouseenter", s), e.el.removeEventListener("mouseleave", r);
      };
    });
    i(this, "addPreview", ({
      teaser: e,
      delay: s = 250
    }) => {
      const { mediaId: r } = e, n = this.getState(r);
      if (!(n != null && n.timeoutId))
        try {
          const a = setTimeout(() => {
            var u;
            const { el: c, video: l } = m({
              image: e.image,
              previewUrl: this.previewUrls[r]
            });
            c && l && (this.setState(r, {
              el: c,
              video: l
            }), this.isVideoPlaying(l) || (u = l.play()) == null || u.catch((L) => {
            }));
          }, s);
          this.setState(r, {
            timeoutId: a
          });
        } catch (a) {
          console.error("Error adding preview:", a);
        }
    });
    i(this, "isVideoPlaying", (e) => e.currentTime > 0 && !e.paused && !e.ended && e.readyState > e.HAVE_CURRENT_DATA);
    i(this, "removePreview", (e) => {
      var r, n;
      const s = this.getState(e);
      if (s)
        try {
          (r = s.video) == null || r.pause(), (n = s.el) == null || n.remove(), s.timeoutId && clearTimeout(s.timeoutId), this.removeState(e);
        } catch (a) {
          console.error("Error removing preview:", a);
        }
    });
    this.update(e);
  }
}
const g = `
<svg viewBox="-20 -15 50 50">
  <defs>
    <filter id="shadow">
      <feDropShadow dx="0" dy="0" stdDeviation="2"></feDropShadow>
    </filter>
  </defs>
  <g>
    <circle class="icon-bg" cx="5" cy="10" fill="#333" fill-opacity="0.7" r="18.5" stroke-width="0"></circle>
  </g>
  <g>
    <path d="M 0,0 0,20 14,10 Z" fill="currentColor"></path>
  </g>
  <g>
    <circle class="progress-bar" cx="-10" cy="5" fill-opacity="0" r="18.5" stroke="currentColor" stroke-dasharray="117" stroke-dashoffset="0" stroke-width="3" transform="rotate(-90)"></circle>
  </g>
</svg>`;
function E({
  image: o,
  countdownDuration: t,
  svgIcon: e,
  onCancelCallback: s
}) {
  const r = A(o.offsetWidth, o.offsetHeight), n = S(e), a = T(s);
  r.append(n, a);
  const c = window.setTimeout(() => {
    o.click();
  }, t);
  return o.insertAdjacentElement("afterend", r), {
    el: r,
    countdownTimeoutId: c,
    startTime: Date.now(),
    progressCircle: n.querySelector(".progress-bar")
  };
}
function S(o) {
  const t = document.createElement("div");
  return t.innerHTML = o, t;
}
function T(o) {
  const t = document.createElement("div");
  return t.innerText = "Annuleer", t.style.textAlign = "center", t.style.textShadow = "0 0 2px #000 !important", t.style.fontSize = "12px", t.style.color = "#FFFFFF", t.style.fontFamily = "Arial, Helvetica, sans-serif", t.style.transformOrigin = "50% 0", t.style.margin = "0 -100%", t.onclick = (e) => {
    e.preventDefault(), o && o();
  }, t;
}
function A(o, t) {
  const e = document.createElement("div");
  return e.style.cursor = "pointer", e.style.width = D(o, 30, 140, 120, 800) + "px", e.style.position = "absolute", e.style.top = t / 2 + "px", e.style.left = o / 2 + "px", e.style.transform = "translate(-50%, -50%)", e.style.zIndex = "9999999", e.style.color = "#FFFFFF", e;
}
function D(o, t, e, s, r) {
  const a = (Math.max(s, Math.min(r, o)) - s) / (r - s);
  return t + a * (e - t);
}
class x extends d {
  constructor(e) {
    super();
    i(this, "state", {});
    i(this, "options", {});
    i(this, "update", (e) => {
      this.setTeasers(e.items);
    });
    i(this, "remove", () => {
      this.teasers.forEach((e) => {
        this.detachListeners(e);
      }), this.teasers = [], Object.keys(this.state).forEach((e) => {
        this.removeAutostart(e);
      });
    });
    i(this, "attachListeners", (e) => {
      const s = () => {
        this.addAutostart({
          teaser: e
        });
      }, r = () => {
        this.removeAutostart(e.mediaId);
      };
      e.el.addEventListener("mouseenter", s), e.el.addEventListener("mouseleave", r), e.cleanup = () => {
        e.el.removeEventListener("mouseenter", s), e.el.removeEventListener("mouseleave", r);
      };
    });
    i(this, "addAutostart", ({ teaser: e }) => {
      const { mediaId: s } = e, {
        countdownDuration: r,
        showDelay: n,
        svgIcon: a
      } = this.options, c = this.getState(s);
      if (c != null && c.countdownTimeoutId || c != null && c.cancelled)
        return;
      const l = window.setTimeout(() => {
        const u = E({
          image: e.image,
          countdownDuration: r,
          svgIcon: a,
          onCancelCallback: () => {
            this.state[s].cancelled = !0, this.cancelTimeouts(s);
          }
        });
        this.setState(s, u), this.updateProgress(s);
      }, n);
      this.setState(s, { showDelayTimeoutId: l });
    });
    i(this, "updateProgress", (e) => {
      const s = this.getState(e), { countdownDuration: r } = this.options;
      if (s != null && s.progressCircle) {
        const n = Date.now() - s.startTime, a = n / r;
        s.progressCircle.style.strokeDashoffset = `${117 * (1 - a)}`, n < r && window.requestAnimationFrame(() => {
          this.updateProgress(e);
        });
      }
    });
    i(this, "removeAutostart", (e) => {
      if (this.state[e])
        try {
          this.cancelTimeouts(e), this.removeState(e);
        } catch (s) {
          console.error("Error removing auto start:", s);
        }
    });
    i(this, "cancelTimeouts", (e) => {
      var r;
      const s = this.state[e];
      s && ((r = s.el) == null || r.remove(), window.clearTimeout(s.showDelayTimeoutId), window.clearTimeout(s.countdownTimeoutId));
    });
    this.options = {
      showDelay: e.showDelay || 2e3,
      countdownDuration: e.countdownDuration || 6e3,
      svgIcon: e.svgIcon || g
    }, this.update(e);
  }
}
const I = (o = "data-spark-video-id") => {
  const t = document.querySelectorAll(`[${o}]`);
  return Array.from(t).reduce((e, s) => {
    const r = s.getAttribute(o);
    return r && e.push({
      mediaId: r,
      el: s
    }), e;
  }, []);
};
document.addEventListener("DOMContentLoaded", function() {
  const o = I();
  new w({ items: o }), new x({ items: o });
});
export {
  x as AutostartPlugin,
  w as PreviewPlugin
};
